import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/black-scholes-calculator',
  component: () => import('../../routes/BlackScholesCalculator.svelte'),
  card: {
    id: 'black-scholes-calculator',
    title: 'Black-Scholes Calculator',
    description: 'Calculate the fair value of European call and put options using the Black-Scholes-Merton model, with full Greeks (delta, gamma, theta, vega, rho).',
    icon: 'candlestick_chart',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/black-scholes-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Black-Scholes Option Pricing Calculator – Fair Value & Greeks',
    description:
      'Free Black-Scholes calculator to find the fair market price of European call and put options. Includes delta, gamma, theta, vega, and rho Greeks. Uses the famous Black-Scholes-Merton model.',
  },
};

export default meta;